import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { InjuryNature } from "../../../../api";
import { useLanguage } from "../../../../contexts";

const ctrl = new InjuryNature();

export function InjuryNatureForm({ item, close, onReload }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: { name: item?.name || "" },
    validationSchema: Yup.object({ name: Yup.string().required("El nombre es requerido") }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const payload = { name: values.name.charAt(0).toUpperCase() + values.name.slice(1) };
        if (item) {
          await ctrl.updateInjuryNature(item._id, payload);
          toast.success(t("updated"));
        } else {
          await ctrl.createInjuryNature(payload);
          toast.success(t("created"));
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || t("error"));
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<label>{t("name")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="name"
        value={formik.values.name}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("name", v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1) : v);
        }}
        error={formik.errors.name}
        placeholder="Ej: Fractura cerrada"
        autoFocus
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (item ? t("update") : t("save"))}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>{t("cancel")}</button>
      </div>
    </Form>
  );
}
